import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import Swiper from "react-id-swiper";

const ProductImageGallery = ({ product,image,setnull }) => {
  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [bool,setbool] = useState(true)
  // effect for swiper slider synchronize
  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  // swiper slider settings
  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    spaceBetween: 10,
    loopedSlides: 4,
    loop: true,
    effect: "fade"
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    loopedSlides: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    )
  };
  const ciao=()=>{
    console.log("ho cliccato")
    setnull()
  }
  
  return (
    <Fragment>
      <div className="product-large-image-wrapper">
        {product.discount || product.new || product.isGratis ? (
          <div className="product-img-badges">
            {product.discount ? (
              <span className="scontotag">-{product.discount}%</span>
            ) : (
              ""
            )}
            {product.new ? <span className="newtag">New</span> : ""}
            {product.isGratis ? <span className="spedizionetag">Spedizione Gratis</span> : ""}
          </div>
        ) : (
          ""
        )}
        {/* */}
        <LightgalleryProvider>
          <Swiper {...gallerySwiperParams}>
            {product.image &&
              product.image.map((single, key) => {
                return (
                  <div key={key}>

                    <LightgalleryItem
                      group="any"
                      src={process.env.PUBLIC_URL + single}
                    >

                      <button >
                        <i className="pe-7s-expand1"></i>
                      </button>
                    </LightgalleryItem>
                  {console.log(image)} 
                    {image != ""  ?
                      <div className="single-image">
                        <img
                          style={{backgroudColor:"white"}} 
                          src={process.env.PUBLIC_URL + image}
                          className="img-fluid"
                          alt=""
                        />
                      </div>

                      :
                        
                    <div className="single-image">
                      <img
                        style={{backgroudColor:"white"}} 
                        src={process.env.PUBLIC_URL + single}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  }
                  

                  </div>
                );
              })}
          </Swiper>
        </LightgalleryProvider>
      </div>
      <div className="product-small-image-wrapper mt-15">

        <Swiper {...thumbnailSwiperParams}>
          {product.image &&
           
            product.image.map((single, key) => {
              return (
                <div key={key}>
                  <div className="single-image">
                    <img
                      style={{backgroudColor:"white"}} 
                      src={process.env.PUBLIC_URL + single}
                      className="img-fluid"
                      alt=""
                      onClick={()=>ciao()}
                    />
                  </div>
                </div>
              );
            })}
        </Swiper>

      </div>
    </Fragment>
  );
};

ProductImageGallery.propTypes = {
  product: PropTypes.object
};

export default ProductImageGallery;
